import Vue from 'vue'
require('intersection-observer');
import VueObserveVisibility from 'vue-observe-visibility'
Vue.use(VueObserveVisibility)
import store from './store/index'
import space_router from './router'
import id_router from './router/id'

import App from './App.vue'
import vuetify from './plugins/vuetify'
import i18n from './plugins/i18n'
import VueCookies from 'vue-cookies'
import VueTextareaAutosize from "vue-textarea-autosize";
import linkify from 'vue-linkify'
import AudioComponent from './components/editor_extensions/audio-component.vue'
import VuetifyAudio from './components/vuetify_components/Audio.vue'
import VuePapaParse from 'vue-papa-parse'
import VueGoogleAutocomplete from "vue-google-autocomplete"

Vue.use(VuePapaParse)

Vue.use(VueTextareaAutosize);

import { VList } from 'vuetify/lib';
Vue.component("v-list", VList)
Vue.component("audio-component", AudioComponent)
Vue.component("vuetify-audio", VuetifyAudio)
Vue.component('vue-google-autocomplete', VueGoogleAutocomplete);

import axios from 'axios'

import { initResponseInterceptor } from './interceptors.js'

import Echo from "laravel-echo"
import * as Sentry from "@sentry/vue";

window.Pusher = require('pusher-js')
if (window.$cookies.get("token")) {
    window.Echo = new Echo({
        broadcaster: 'pusher',
        key: process.env.VUE_APP_PUSHER_KEY,
        cluster: 'eu',
        encryted: true,
        authEndpoint: process.env.VUE_APP_API_BASE_URL + "/v1/broadcasting/auth",
        auth: {
            headers: {
                'Accept': "application/vnd.api+json",
                'Authorization': 'Bearer ' + window.$cookies.get("token")
            }
        },
    });
}

Vue.config.productionTip = false

Vue.config.ignoredElements = ['section-separator', 'column-separator']

Vue.directive('linkified', linkify)

Vue.directive('visible', function(el, binding) {
    el.style.visibility = binding.value ? 'visible' : 'hidden';
})

Vue.directive('colors', {
        // When the bound element is inserted into the DOM...
        /*inserted(el, binding) {
          var colors = ['#006CFB', '#e4e5ff', '#abb2ff', '#6082fd', '#c9cbff', '#899afe'];
          var row_id = binding.value;

        if(row_id > 5){
            while (row_id > 5) {
                row_id = row_id - 6
            }
        } 
            el.style.borderLeft = "5px solid";
            el.style.borderLeftColor = colors[row_id];
        }*/
        inserted(el) {
            el.style.borderLeft = "5px solid";
            el.style.borderLeftColor = "#006CFB"
        }

    })

    //load right route file
const space = window.location.host.split('.')[0];
const router = () => {
    let routes;
    if (space == 'id') {
        routes = id_router;
    } else {
        routes = space_router;
    }
    return routes;
};
//set default authorization token after refresh
if (window.$cookies.get("token") != null) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + window.$cookies.get("token");
}

// intercepting responses
initResponseInterceptor()

Sentry.init({
    Vue,
    environment: process.env.NODE_ENV,
    dsn: process.env.VUE_APP_SENTRY_URL,
    sendDefaultPii: true,
    integrations: [
        // Sentry.browserTracingIntegration({ router }),
        Sentry.replayIntegration({
            maskAllText: true,
            blockAllMedia: true,
        }),
    ],

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
});

new Vue({
    i18n,
    store,
    router: router(),
    vuetify,
    VueCookies,
    render: h => h(App)
}).$mount('#app')